import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Container,
  Heading,
  Text,
} from '@chakra-ui/react'

import { ListSessionsPage } from '@features/sessions/components/ListSessionsPage'
import { ErrorBoundary } from '@sentry/react'
import { Route as listProjectsRoute } from '@routes/_auth/o/$orgId/projects'
import { withSentryErrorReporting } from '@components/Fallback'
import {
  DEFAULT_LIST_ORDER,
  listSessionRequestPaginationSchema,
  SESSION_ORDER_BY_FIELDS,
} from '@customTypes/cloudmix/sessions'
import { withListHydration } from '@lib/listState/withListHydration'

const ManageSessionsFallback = () => {
  const { orgId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/',
  })

  return (
    <Card variant={'outline'}>
      <CardBody>
        <Heading size="md">
          There seems to be a problem loading this project.
        </Heading>
        <Text py="2">
          Try loading the page again or select another project from the list
        </Text>
      </CardBody>
      <CardFooter>
        <Link to={listProjectsRoute.to} params={{ orgId }}>
          <Button>Back to project list</Button>
        </Link>
      </CardFooter>
    </Card>
  )
}

const ListSessionsRoute = () => {
  const { projectId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/',
  })

  return (
    <ErrorBoundary fallback={<ManageSessionsFallback />}>
      <Container maxW={'75rem'}>
        <ListSessionsPage projectId={projectId} />
      </Container>
    </ErrorBoundary>
  )
}

const routerSchema = listSessionRequestPaginationSchema.partial().catch({})
export const Route = createFileRoute('/_auth/o/$orgId/projects/$projectId/s/')({
  component: ListSessionsRoute,
  errorComponent: withSentryErrorReporting(ManageSessionsFallback),
  beforeLoad: withListHydration({
    list: {
      getScope: (params) => params.projectId,
      defaultSort: DEFAULT_LIST_ORDER,
      allowedOrderByFields: SESSION_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Sessions',
  }),
  validateSearch: zodValidator(routerSchema),
})
